import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import { FileType } from '~/core/enums';
import PDFViewer from '~/core/components/PDFViewer/PDFViewer.vue';
import { GALLERY_EMIT_ERROR_INJECTION, GALLERY_TOOLBAR_HEIGHT } from './constants';
import FullscreenGalleryItemImg from './FullscreenGalleryItemImg.vue';
export default defineComponent({
  name: 'FullscreenGalleryItem',
  components: {
    PDFViewer: PDFViewer,
    FullscreenGalleryItemImg: FullscreenGalleryItemImg
  },
  props: {
    src: {
      type: [File, Function],
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    }
  },
  emits: {
    loaded: function loaded(_) {
      return true;
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      expose = _ref.expose;
    var emitError = inject(GALLERY_EMIT_ERROR_INJECTION);
    var innerSrc = ref('');
    var innerFileInstance = ref(null);
    var item = ref(null);
    var isLoading = computed(function () {
      return !innerFileInstance.value || !innerSrc.value;
    });
    var isPDFFile = computed(function () {
      return innerFileInstance.value && innerFileInstance.value.type === FileType.Pdf;
    });
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (!(props.src instanceof Function)) {
              _context.next = 7;
              break;
            }
            _context.next = 4;
            return props.src();
          case 4:
            _context.t0 = _context.sent;
            _context.next = 8;
            break;
          case 7:
            _context.t0 = props.src;
          case 8:
            innerFileInstance.value = _context.t0;
            innerSrc.value = URL.createObjectURL(innerFileInstance.value);
            emit('loaded', {
              file: innerFileInstance.value,
              zoom: function zoom(zoomFactor) {
                var _item$value;
                return (_item$value = item.value) === null || _item$value === void 0 ? void 0 : _item$value.zoom(zoomFactor);
              },
              isZoomApplied: function isZoomApplied() {
                var _item$value$isZoomApp, _item$value2;
                return (_item$value$isZoomApp = (_item$value2 = item.value) === null || _item$value2 === void 0 ? void 0 : _item$value2.isZoomApplied()) !== null && _item$value$isZoomApp !== void 0 ? _item$value$isZoomApp : false;
              }
            });
            _context.next = 18;
            break;
          case 13:
            _context.prev = 13;
            _context.t1 = _context["catch"](0);
            innerSrc.value = '';
            innerFileInstance.value = null;
            emitError === null || emitError === void 0 ? void 0 : emitError(_context.t1);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 13]]);
    })));
    onBeforeUnmount(function () {
      URL.revokeObjectURL(innerSrc.value);
    });
    expose({
      zoom: function zoom(zoomFactor) {
        var _item$value3;
        return (_item$value3 = item.value) === null || _item$value3 === void 0 ? void 0 : _item$value3.zoom(zoomFactor);
      },
      isZoomApplied: function isZoomApplied() {
        var _item$value4;
        return (_item$value4 = item.value) === null || _item$value4 === void 0 ? void 0 : _item$value4.isZoomApplied();
      }
    });
    return {
      item: item,
      innerSrc: innerSrc,
      isPDFFile: isPDFFile,
      isLoading: isLoading,
      GALLERY_TOOLBAR_HEIGHT: GALLERY_TOOLBAR_HEIGHT
    };
  }
});